'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = require('vuex');

var _bayWindow = require('@/components/bay-window');

var _bayWindow2 = _interopRequireDefault(_bayWindow);

var _header = require('@/page/header');

var _header2 = _interopRequireDefault(_header);

var _footer = require('@/page/footer');

var _footer2 = _interopRequireDefault(_footer);

var _store = require('@/store');

var _store2 = _interopRequireDefault(_store);

var _utils = require('@/utils');

var _language = require('@/utils/language');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'App',
  computed: {
    defaultLangCode: function defaultLangCode() {
      return (0, _utils.getDefaultLangCode)(this.$store.state.langList);
    },
    isIE: function isIE() {
      return (/trident/i.test(navigator.userAgent)
      );
    }
  },
  created: function created() {
    this.init();
  },

  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)({
    skin: 'SKIN'
  }), {
    init: function init() {
      var _this = this;

      return (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var lang;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$local.getItem('lang');

              case 2:
                _context.t0 = _context.sent;

                if (_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = _this.defaultLangCode;

              case 5:
                lang = _context.t0;

                _this.setLang(lang);
                _this.showDom();
                _this.setBg();
                _this.asyncLang = true;

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setLang: function setLang(lang) {
      this.$i18n.locale = lang;
      document.body.setAttribute('lang', lang);
      localStorage.setItem('lang', lang);
      this.$local.setItem('lang', lang);
    },
    showDom: function showDom() {
      //todo  修改为全局配置
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(_store2.default.state.hideRouterName), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;

          if (this.$route.path === '/' || this.$route.path.indexOf(item) > -1) {
            this.showHF = false;
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.showHF = true;
    },
    setBg: function setBg() {
      var bodtDom = document.getElementsByTagName('body')[0];
      for (var item in _store2.default.state.bgRouter) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = (0, _getIterator3.default)(_store2.default.state.bgRouter[item]), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var i = _step2.value;

            if (this.$route.path.indexOf(i) > -1) {
              bodtDom.style.background = item;
              return;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
      bodtDom.style.background = '#fff';
    },
    compatibleAnimation: function compatibleAnimation() {
      window.requestAnimationFrame = window.requestAnimationFrame || function (fn) {
        return setTimeout(fn, 1000 / 60);
      };
      window.cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout;
    },
    initFooter: function initFooter() {
      this.$refs.Footer.initScroll();
    },
    setRuntimeAttr: function setRuntimeAttr() {
      document.body.setAttribute('runtime', this.isIE ? 'compatible' : 'standard');
    }
  }),
  data: function data() {
    return {
      mainstyle: {
        'min-height': '100%'
      },
      bgstyle: {
        'background': '#fff'
      },
      showHF: false,
      $local: '',
      $i18n: '',
      $api: '',
      asyncLang: false
    };
  },
  mounted: function mounted() {
    this.compatibleAnimation();
    this.setRuntimeAttr();
  },

  watch: {
    '$route': function $route() {
      var _this2 = this;

      this.showDom();
      this.setBg();
      this.compatibleAnimation();
      this.$nextTick(function () {
        if (_this2.$i18n.locale === 'ar_AR') {
          new _language.AlaboLanguage({
            el: '#app'
          }).invokeStyle();
        }
      });
    },
    defaultLangCode: function defaultLangCode() {
      this.init();
    }
  },
  components: {
    Heade: _header2.default,
    Footer: _footer2.default,
    BayWindow: _bayWindow2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//